import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { MobilyForm as mobilyForm } from "mobilyform/lib"
import { withTranslation } from "react-i18next";
import { formModal } from "./data"
import { COMPONENTS } from "Constants"
import { complainsApi } from "api"
import { encrypt } from "core/utils/encrypt"
import { error, success } from "core/utils/toast"
import { UseSharedData } from "contexts";

const win: any = window;
const lang = win['lang']
const rtl = !(lang === "en")
const lang_prefix = (rtl ? "Ar" : "En")

const MobilyForm: any = mobilyForm




const FindComplaint = ({ setCurrentComponent }: any) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false)
  const { Reducer } = UseSharedData();


  useEffect(() => {
    // complainsApi.getIDTypes().then((res: any) => {
    //   setIdTypes(res.typesList)
    //   setLoading(false)
    // }).catch(e => {
    //   console.log(e)
    //   setLoading(false)
    // })
  }, [])
  const submit = (formInstance: any) => {
    setLoading(true)
    let formValues = formInstance.getFieldsValue()
    let payload = {
      idNumber: formValues.idNumber,
      srNumber: formValues.srNumber
    }
    complainsApi.checkComplain(payload).then((res: any) => {
      let info = res.crmServiceRequestList.serviceRequest[0]
      console.log('info=>', info)
      Reducer?.setComplaintsInfo(info)
      setCurrentComponent(COMPONENTS.ComplaintInfo)
      setLoading(false)
    }).catch(e => {
      console.log(e.toString())
      error(e.toString())
    })


  }
  return <div>
    <MobilyForm
      formRef={React.createRef()}
      formModal={formModal(() => { },
        false,
        t,
        submit)}
      loading={loading}
    ></MobilyForm>
  </div>;
}


export default FindComplaint;